import React, { useEffect } from "react";
import "./DaanUtsavProject1.css";
import image1 from "../../../images/KU team 2025/Project 1/WhatsApp Image 2025-11-03 at 10.07.19 AM.jpeg";
import image2 from "../../../images/KU team 2025/Project 1/WhatsApp Image 2025-11-03 at 10.07.19 AM (1).jpeg";
import image3 from "../../../images/KU team 2025/Project 1/WhatsApp Image 2025-11-03 at 10.07.19 AM (2).jpeg";
import image4 from "../../../images/KU team 2025/Project 1/WhatsApp Image 2025-11-03 at 10.07.20 AM.jpeg";
import image5 from "../../../images/KU team 2025/Project 1/WhatsApp Image 2025-11-03 at 10.07.20 AM (1).jpeg";

const DaanUtsavProject1 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="daanutsav-project1">
      <div className="center-part col">
        <div className="project-head row">Daan Utsav 2025 - DLLE St. Andrew's College</div>

        <div className="row image-row">
          <img className="col-md-4 photo-project" src={image1} alt="Daan Utsav Event 1" />
          <img className="col-md-4 photo-project" src={image2} alt="Daan Utsav Event 2" />
          <img className="col-md-4 photo-project" src={image3} alt="Daan Utsav Event 3" />
        </div>

        <div className="row image-row">
          <img className="col-md-6 photo-project" src={image4} alt="Daan Utsav Event 4" />
          <img className="col-md-6 photo-project" src={image5} alt="Daan Utsav Event 5" />
        </div>

        <p className="text">
          Kindness Unlimited joined Daan Utsav – India's Festival of Giving (Oct 2–8) in collaboration with DLLE, St. Andrew's College of Arts, Science and Commerce, Bandra, to spread joy and compassion through volunteering. The collected stationery was shared with schools affected by floods through Goonj, reflecting the spirit of community and empathy.
        </p>

        <div className="instagram-link">
          <a href="https://www.instagram.com/p/DPSxFryD8wb/?img_index=1&igsh=aDZ2dmNsZHV2Mm4z" target="_blank" rel="noopener noreferrer" className="instagram-button">
            <i className="fab fa-instagram"></i> View on Instagram
          </a>
        </div>
      </div>
    </section>
  );
};

export default DaanUtsavProject1;
